const uiSchema = {
  claimtype: {
    classNames: "hidden"
  },
  claimMotor: {
    classNames: "hidden"
  },
  claimNonMotor: {
    classNames: "hidden"
  }
};

export default uiSchema;
